import type { Meta, StoryObj } from '@storybook/angular';
import { moduleMetadata } from '@storybook/angular';
import { expect } from 'storybook/test';
import { FooterTopComponent } from '../../app/content/layout/components/general/footer/components/footer-top/footer-top.component';
import { FooterNewsletterComponent } from '../../app/content/layout/components/general/footer/components/footer-newsletter/footer-newsletter.component';
import { FooterOurStoresComponent } from '../../app/content/layout/components/general/footer/components/footer-our-stores/footer-our-stores.component';
import { FooterInfoAndLinksComponent } from '../../app/content/layout/components/general/footer/components/footer-info-and-links/footer-info-and-links.component';
import { FooterBottomComponent } from '../../app/content/layout/components/general/footer/components/footer-bottom/footer-bottom.component';
import { withCommonDecorators } from '../_utils/story-helpers';

const meta: Meta = {
  title: 'Compositions/Footer Assembly',
  tags: ['autodocs'],
  decorators: [
    ...withCommonDecorators(),
    moduleMetadata({
      imports: [
        FooterTopComponent,
        FooterNewsletterComponent,
        FooterOurStoresComponent,
        FooterInfoAndLinksComponent,
        FooterBottomComponent,
      ],
    }),
  ],
  parameters: {
    layout: 'fullscreen',
    docs: {
      description: {
        component: 'Full footer assembly showing all footer sections stacked together as they appear on the live site.',
      },
    },
  },
};
export default meta;
type Story = StoryObj;

export const FullFooter: Story = {
  render: () => ({
    template: `
      <footer style="background: #1a1a2e; color: #f0f0f0;">
        <app-footer-top></app-footer-top>
        <app-footer-newsletter></app-footer-newsletter>
        <app-footer-our-stores></app-footer-our-stores>
        <app-footer-info-and-links></app-footer-info-and-links>
        <app-footer-bottom></app-footer-bottom>
      </footer>
    `,
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('footer')).toBeTruthy();
    await expect(canvasElement.querySelector('app-footer-top')).toBeTruthy();
    await expect(canvasElement.querySelector('app-footer-bottom')).toBeTruthy();
  },
};

export const TopAndNewsletter: Story = {
  render: () => ({
    template: `
      <div style="background: #1a1a2e; color: #f0f0f0;">
        <app-footer-top></app-footer-top>
        <app-footer-newsletter></app-footer-newsletter>
      </div>
    `,
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-footer-top')).toBeTruthy();
    await expect(canvasElement.querySelector('app-footer-newsletter')).toBeTruthy();
  },
};

export const LinksAndLegal: Story = {
  render: () => ({
    template: `
      <div style="background: #1a1a2e; color: #f0f0f0;">
        <app-footer-info-and-links></app-footer-info-and-links>
        <app-footer-bottom></app-footer-bottom>
      </div>
    `,
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-footer-info-and-links')).toBeTruthy();
    await expect(canvasElement.querySelector('app-footer-bottom')).toBeTruthy();
  },
};
